import { useEffect } from 'react';
import options from '../../data/options';
import {
  setDisableNext,
  setDisablePrev,
  setField,
} from '../../features/providers/dataSlice';
import { useDispatch, useSelector } from 'react-redux';

const Step1 = ({ number }) => {
  const dispatch = useDispatch();
  const userName = useSelector((state) => {
    return state.data.formData.userName;
  });

  useEffect(() => {
    dispatch(setDisableNext({ number, disabled: !userName }));
    dispatch(setDisablePrev({ number, disabled: false }));
  }, [userName]);

  return (
    <>
      <p className="text-primary text-h3 font-bold mb-1">What's Your Name?</p>
      <input
        type="text"
        className="border-[#DEC8FF] border-2 rounded-[5px] p-5"
        value={userName}
        onChange={(e) =>
          dispatch(setField({ field: 'userName', value: e.target.value }))
        }
      />
    </>
  );
};

export default Step1;
